import { BaseRequests } from "../../../config/BaseRequests";
import { supportApiEndpoints } from "../api/support.api";
import {
  AboutContent,
  ConversationRow,
  ConversationThread,
  FeedbackRow,
  ThreadMessage,
} from "../dto/index.dto";
import { PaginatedResponse } from "../../../shared/dto/pagination.dto";

export class SupportService {
  static getConversations = (
    page: number,
    limit: number
  ): Promise<PaginatedResponse<ConversationRow>> =>
    BaseRequests.get(supportApiEndpoints.getConversations(page, limit));

  static getConversationThread = (
    userId: string
  ): Promise<ConversationThread> =>
    BaseRequests.get(supportApiEndpoints.getConversationThread(userId));

  static sendMessage = (
    userId: string,
    content: string
  ): Promise<ThreadMessage> =>
    BaseRequests.post(supportApiEndpoints.sendMessage(userId), { content });

  static getFeedbacks = (
    page: number,
    limit: number
  ): Promise<PaginatedResponse<FeedbackRow>> =>
    BaseRequests.get(supportApiEndpoints.getFeedbacks(page, limit));

  static getAbout = (): Promise<AboutContent> =>
    BaseRequests.get(supportApiEndpoints.getAbout);

  static updateAbout = (content: string): Promise<AboutContent> =>
    BaseRequests.patch(supportApiEndpoints.updateAbout, { content });
}
